import React from 'react';

export default function CookieBar(props) {
  

  return (
    
      <div className="cookie-bar-container">
        <div className="container">
          <div className="row">
            <div className="col-9">
            <p>RC Ferret uses local storage to improve your experience on our site. By continuing to use this website, you consent to the use of cookies and local storage in accordance with our <a onClick={props.onShowPolicy} href="#">Cookie Policy</a></p>
            </div>
            <div className="col-2 col-md-1 p-0">
            <button className="btn btn-primary" onClick={props.onAcceptance}>Accept</button>
            </div>
          </div>
        </div>
      </div>
    
  );
}

